import React from 'react';
import {Table} from 'web-components';

export const getBaseLevelTableHeader = columns => {
	return (
		<Table.Header backgroundColor={'#f5f5f8'}>
			<Table.HeaderColumn align="left" visible={true} width="LARGE">
				<Table.HeaderColumn.Title>{'Insight'}</Table.HeaderColumn.Title>
			</Table.HeaderColumn>
			<Table.HeaderColumn flex={1} align="left" visible={true} width="LARGE">
				<Table.HeaderColumn.Title>{'Details'}</Table.HeaderColumn.Title>
			</Table.HeaderColumn>
			<Table.HeaderColumn align="right" visible={true} width="MEDIUM_SMALL">
				<Table.HeaderColumn.Title>{'Action'}</Table.HeaderColumn.Title>
			</Table.HeaderColumn>
		</Table.Header>
	);
};
